export default __webpack_public_path__ + "f498338821cbdacf9c91562a6b490b9f.pdf";